module.exports = __webpack_public_path__ + "img/success2.9b99021b.gif";